module.exports = __webpack_public_path__ + "img/choose-account.644a4df0.jpg";